<template>
  <!--  banner 轮播部分-->
<!--  <page-banner :pageNumber="8" />-->
  <crumbs />
  <div class="mainContainer">
    <show-content :detail="detail"/>
  </div>
</template>

<script setup>
// import ShowContent from "../../components/showContent";
import {getGGDetail} from "../../../apis/xxgk";

const currentActivePage = ref("");
const _id = ref("");
const detail = ref({})

const route = useRoute();
currentActivePage.value = route.query.from;
_id.value = route.params.id;

const {data} = await useAsyncData('getGGDetail', () => getGGDetail(_id.value))

if (data.value.code !== 200) {
  throw createError({statusCode: data.value.code, statusMessage: encodeURIComponent("公告详情")})
} else {
  detail.value = data.value.data
}


// 设置TDK
useHead({
  title: `${detail.value.contentTitle} - 郑州路桥建设投资集团有限公司`,
})
</script>

<style scoped>

</style>